<template lang="html">
	<div class="om-page" :class="classes">
		<h1 v-if="title">{{ title }}</h1>
		<slot><p>Page content goes here...</p></slot>
	</div>
</template>

<script lang="js">

export default  {
	name  : 'core-page',
	props : [ 'title', 'classes' ],
	mounted () {

	},
	data () {
		return {

		}
	},
	methods : {

	},
	computed : {

	},
}

</script>

<style lang="scss">
  .om-page {
	  padding: 30px 40px 0;
  }
</style>
